var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"c-hamburger",on:{"click":_vm.openModal}},_vm._l((3),function(n){return _c('span',{key:"bar" + n,staticClass:"bar"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }